// extracted by mini-css-extract-plugin
export var featuredImageHeight = "40vh";
export var navbarHeight = "50rem";
export var maxFooterHeight = "64rem";
export var blogMenu = "Menu-module--blog-menu--30xrK";
export var offsetByFeaturedImage = "Menu-module--offset-by-featured-image--1hGta";
export var blogMenuButton = "Menu-module--blog-menu-button--1AtTt";
export var footerInView = "Menu-module--footer-in-view--2CIoa";
export var open = "Menu-module--open--2X7rh";